import { hasValue } from "@itk/typescript-utils";
import { composeWithDevTools } from "@redux-devtools/extension";
import { applyMiddleware, compose, legacy_createStore } from "redux";
import createSagaMiddleware from "redux-saga";
import { rootReducer } from "./reducer";
import { rootSaga } from "./saga";
import { errorActions as errorActions } from "src/components/error-viewer/error-store";
import { initialItkComponentsReducerState } from "./itk-components-reducer-state";

const cachedGeneralReducers = ["applicationReducer"] as const;

const sagaMiddleware = createSagaMiddleware({
  onError: err => {
    store.dispatch(errorActions.addError(err));
  }
});

const configureStore = () => {
  const middlewares = [sagaMiddleware];
  const middlewareEnhancer = applyMiddleware(...middlewares);

  let generalReducerCache: Record<string, unknown> = {};

  for (const reducer of cachedGeneralReducers) {
    const cacheString = localStorage.getItem(`DEKO-X-CACHE-${reducer}`);
    const cache = hasValue(cacheString) ? JSON.parse(cacheString) : undefined;
    generalReducerCache = { ...generalReducerCache, [reducer]: cache };
  }

  const composed = process.env.NODE_ENV === "production" || process.env.NODE_ENV === "staging" ? compose(middlewareEnhancer) : composeWithDevTools(middlewareEnhancer);
  const store = legacy_createStore(rootReducer, { generalReducer: generalReducerCache, itkComponentsReducer: initialItkComponentsReducerState }, composed);

  sagaMiddleware.run(rootSaga);

  return store;
};

export const store = configureStore();

export type RootState = ReturnType<typeof store.getState>;
